import React, { useContext, useImperativeHandle, useState, useMemo } from 'react';
import { Button, Modal, Space, Steps, message } from 'antd';
import SPFilterTable from './SPFilterTable';

interface SPFilterRecordListType {
  value: any;
  filterProps: any;
  metaConfig: any;
  activeKey?: string | undefined;
  activeData?: any;
  mainRecordValue: any;
  _headIdField?: string;
  headIdData?: string;
  onChange: (data: any) => void;
}
const SPFilterRecordList: React.FC<SPFilterRecordListType> = function SPFilterRecordList({
  value,
  filterProps,
  activeKey,
  activeData,
  metaConfig,
  mainRecordValue,
  onChange,
  _headIdField,
  headIdData,
  ...others
}) {
  return (
    <SPFilterTable
      value={value}
      mainRecordValue={mainRecordValue}
      filterProps={filterProps}
      activeKey={activeKey}
      activeData={activeData}
      metaConfig={metaConfig}
      _headIdField={_headIdField}
      headIdData={headIdData}
      onChange={onChange}
      {...others}
    />
  );
};

export default SPFilterRecordList;
